import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { CircularProgress } from '../../../common'

import OfflineModeHeader from '../../../containers/OfflineModeHeader'
import MenuHeader from '../../../containers/MenuHeader'
import FeedItems from '../../../containers/FeedItems'

import * as Constants from '../../../../helpers/Constants'
import * as Styles from './styles'
import * as Strings from './strings'
import * as feedActions from '../../../../actions/Feed'
import * as offlineModeActions from '../../../../actions/OfflineMode'

class News extends Component {
  componentWillMount() {
    const { history, user, offlineMode, data } = this.props

    if (offlineMode) {
      if (!user.offlineModeSignedIn) {
        this.props.setOfflineSetup()
      }
    } else if (!user.fetched) {
      history.push('/')
    } else if (!data.postsFetched) {
      this.props.tryGetPosts(user.token)
    }
  }

  renderContent() {
    const { user, history, offlineMode, data } = this.props

    if (!user.fetched && !offlineMode) {
      history.push('/')
    }

    if (!user.fetched || !data.postsFetched) {
      return <CircularProgress />
    }

    return (
      <div style={Styles.default.container}>
        <div
          style={{
            ...Styles.default.innerContainer,
            marginTop: offlineMode ? 60 : 20
          }}
        >
          <FeedItems />
        </div>
      </div>
    )
  }

  render() {
    const { config, history } = this.props

    return (
      <MenuHeader
        history={history}
        header={Strings.default.NEWS[config.language]}
        selected={Constants.NEWS_FOCUSED}
      >
        <OfflineModeHeader history={history} />
        {this.renderContent()}
      </MenuHeader>
    )
  }
}

function mapStateToProps({ user, feed, config, data }) {
  return { user, feed, config, data }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...offlineModeActions, ...feedActions }, dispatch)
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(News)



// WEBPACK FOOTER //
// ./src/components/pages/feeds/News/index.js